
import {EventBus} from "src/eventBus";

export default {
    jsPlumb: null,
    isReadonly: false,
    store: null,

    setJSPlumb(jsPlumb, readonly, store) {
        this.jsPlumb = jsPlumb;
        this.isReadonly = readonly;
        this.store = store;
    },
    
    reset() {
        if(this.jsPlumb) {
            this.jsPlumb.unbind("beforeDrop");
            this.jsPlumb.unbind("connection");
            this.jsPlumb.unbind("connectionDetached");
            this.jsPlumb.reset();
            this.jsPlumb = null;
        }
    },

    initEndpoints(nodes, newNodes) {
        if(this.isReadonly)
            var readonlyClass = "agNode-readonlyEndpoint";

        for(let i = 0; i < nodes.length; i++) {
            let node = nodes[i];

            let newNode = newNodes.find((newNode) => newNode._id == node.object._id);
            if(newNode)
                continue;

            // no endpoints on satellite nodes
            let satellite = this.store.getters["nodeStore/isSatellite"](node.type);
            if(satellite)
                continue;

            // src (start node does not have src)
            if(node.type != "startNode") {
                let src = {
                    uuid: `src-${node.object._id}`,
                    enabled: !this.isReadonly,
                    isSource: false,
                    isTarget: true, 
                    anchor: [0, 0.5, -1, 0, 0, 0],
                    endpoint: ["Rectangle", {cssClass: "agNode-srcEndpoint " + readonlyClass, width: 12.5, height: 12.5}],
                    connector:  ["Flowchart", {
                        cornerRadius: 5,
                        midpoint: 0.5
                    }],
                    connectorOverlays: [["Arrow", {width: 10, length: 10, location: 0.5}]],
                    maxConnections: -1
                }

                this.jsPlumb.addEndpoint(node.object._id, src);
            }


            // dest
            let dest = {
                uuid: `dest-${node.object._id}`,
                enabled: !this.isReadonly,
                isSource: true,
                isTarget: false, 
                anchor: [1, 0.5, 1, 0, 0, 0],
                endpoint: ["Rectangle", {cssClass: "agNode-destEndpoint " + readonlyClass, width: 12.5, height: 12.5}],
                connector:  ["Flowchart", {
                    cornerRadius: 5,
                    midpoint: 0.5
                }],
                connectorOverlays: [["Arrow", {width: 10, length: 10, location: 0.5}]],
                maxConnections: 1
            }

            // inputs have additional dests 
            if (node.type == "input") {
                let dests = [{name: "", label: "Results"}];
                if(node.object.dest_noResults)
                    dests.push({name: "_noResults", label: "No Results"});
                if(node.object.dest_error)
                    dests.push({name: "_error", label: "Error"});

                for (let j = 0; j < dests.length; j++) {
                    let destDict = dests[j];
                    let name = destDict.name;
                    let label = destDict.label;
                    let y = (j * 2 + 1) / (dests.length * 2);
           
                    let options = {
                        uuid: `dest${name}-${node.object._id}`,
                        anchor: [1, y, 1, 0, 0, 0],
                        connectorOverlays: [["Arrow", { width: 10, length: 10, location: 0.4 }], ["Label", { label: label, location: 0.2, labelStyle: { fill: "#FFFFFF" } }]],
                        parameters: {
                            destName: `dest${name}`
                        }
                    }
                    this.jsPlumb.addEndpoint(node.object._id, options, dest);
                }
            }
            // outputs have additional dests 
            else if (node.type == "output") {
                let dests = [{name: "", label: "Results"}];
                if(node.object.dest_error)
                    dests.push({name: "_error", label: "Error"});

                for (let j = 0; j < dests.length; j++) {
                    let destDict = dests[j];
                    let name = destDict.name;
                    let label = destDict.label;
                    let y = (j * 2 + 1) / (dests.length * 2);
               
                    let options = {
                        uuid: `dest${name}-${node.object._id}`,
                        anchor: [1, y, 1, 0, 0, 0],
                        connectorOverlays: [["Arrow", { width: 10, length: 10, location: 0.4 }], ["Label", { label: label, location: 0.2, labelStyle: { fill: "#FFFFFF" } }]],
                        parameters: {
                            destName: `dest${name}`
                        }
                    }
                    this.jsPlumb.addEndpoint(node.object._id, options, dest);
                }
            }
            // compareNodes have additional dests 
            else if(node.type == "compareNode") {
                let dests = [];
                if(node.object.dest_equal)
                    dests.push({name: "_equal", label: node.object.dest_equal.alias || "Equal"});
                if(node.object.dest_diff)
                    dests.push({name: "_diff", label: node.object.dest_diff.alias || "Diff"});
                if(node.object.dest_aNotB)
                    dests.push({name: "_aNotB", label: node.object.dest_aNotB.alias || "A not B"});
                if(node.object.dest_bNotA)
                    dests.push({name: "_bNotA", label: node.object.dest_bNotA.alias || "B not A"});

                for (let j = 0; j < dests.length; j++) {
                    let destDict = dests[j];
                    let name = destDict.name;
                    let label = destDict.label;
                    let y = (j * 2 + 1) / (dests.length * 2);
      
                    let options = {
                        uuid: `dest${name}-${node.object._id}`,
                        anchor: [1, y, 1, 0, 0, 0],
                        connectorOverlays: [["Arrow", { width: 10, length: 10, location: 0.4 }], ["Label", { label: label, location: 0.2, labelStyle: { fill: "#FFFFFF" } }]],
                        parameters: {
                            destName: `dest${name}`
                        }
                    }
                    this.jsPlumb.addEndpoint(node.object._id, options, dest);
                }
            }
            // switches dests are in cases
            else if(node.type == "switch") {
                for(let j = 0; j < node.object.cases.length; j++)
                {
                    let y = (j*2 + 1)/(node.object.cases.length*2);
                    let label = "";
                    if((node.object.cases[j].caseName === undefined || node.object.cases[j].caseName === "" || node.object.cases[j].caseName === null) && j < (node.object.cases.length - 1))
                        label = "Case " + (j + 1);
                    else
                        label = node.object.cases[j].caseName;

                    if((node.object.cases[j].caseName === undefined || node.object.cases[j].caseName === "" || node.object.cases[j].caseName === null) && j == (node.object.cases.length - 1))
                        label = "Default";

                    let options = {
                        uuid: "dest" + j + "-" + node.object._id,
                        anchor: [1, y, 1, 0, 0, 0],
                        connectorOverlays: [["Arrow", {width: 10, length: 10, location:0.4}], ["Label", {label: label, location: 0.2, labelStyle: {fill: "#FFFFFF"}}]],
                        parameters: {
                            caseIndex: j
                        }
                    }
                    this.jsPlumb.addEndpoint(node.object._id, options, dest);
                }
            }
            // splitNode's dests are in paths
            else if(node.type == "splitNode") {
                for(let j = 0; j < node.object.paths.length; j++) {
                    let y = (j*2 + 1)/(node.object.paths.length*2);
                    let label = "";
                    if((node.object.paths[j].label === undefined || node.object.paths[j].label === "" || node.object.paths[j].label === null))
                        label = "Path " + (j + 1);
                    else
                        label = node.object.paths[j].label;

                    let options = {
                        uuid: `dest${j}-${node.object._id}`,
                        anchor: [1, y, 1, 0, 0, 0],
                        connectorOverlays: [["Arrow", {width: 10, length: 10, location:0.4}], ["Label", {label: label, location: 0.2, labelStyle: {fill: "#FFFFFF"}}]],
                        parameters: {
                            pathIndex: j
                        }
                    }
                    this.jsPlumb.addEndpoint(node.object._id, options, dest);
                }
            }
            else {
                this.jsPlumb.addEndpoint(node.object._id, dest);
            }
        }
    },

    initConnections(nodes, newNodes) {
        // build all connections based on destinations (nodes only have one dest but may have mutliple src)
        for(let i = 0; i < nodes.length; i++){
            let node = nodes[i];

            let newNode = newNodes.find((newNode) => newNode._id == node.object._id);
            if(newNode)
                continue;

            if(node.type == "switch") {
                for(let j = 0; j < node.object.cases.length; j++) {
                    let agCase = node.object.cases[j]
                    if(agCase.dest) {
                        let srcUUID = "dest" + j + "-" + node.object._id;
                        let destUUID = "src-" + agCase.dest._id;
                        let result = this.jsPlumb.connect({uuids:[srcUUID, destUUID]});
                    }
                }
            }
            else if(node.type == "splitNode") {
                for(let j = 0; j < node.object.paths.length; j++) {
                    let agPath = node.object.paths[j]
                    if(agPath.dest) {
                        let srcUUID = "dest" + j + "-" + node.object._id;
                        let destUUID = "src-" + agPath.dest._id;
                        let result = this.jsPlumb.connect({uuids:[srcUUID, destUUID]});
                    }
                }
            }
            else if(node.type == "compareNode") {
                if (node.object.dest_equal) {
                    let srcUUID = "dest_equal-" + node.object._id;
                    if(!!node.object.dest_equal._id){
                        let destUUID = "src-" + node.object.dest_equal._id;
                        let result = this.jsPlumb.connect({ uuids: [srcUUID, destUUID] });
                    }
                }
                if (node.object.dest_diff) {
                    let srcUUID = "dest_diff-" + node.object._id;
                    if(!!node.object.dest_diff._id){
                        let destUUID = "src-" + node.object.dest_diff._id;
                        let result = this.jsPlumb.connect({ uuids: [srcUUID, destUUID] });
                    }
                }
                if (node.object.dest_aNotB) {
                    let srcUUID = "dest_aNotB-" + node.object._id;
                    if(!!node.object.dest_aNotB._id){
                        let destUUID = "src-" + node.object.dest_aNotB._id;
                        let result = this.jsPlumb.connect({ uuids: [srcUUID, destUUID] });
                    }
                }
                if (node.object.dest_bNotA) {
                    let srcUUID = "dest_bNotA-" + node.object._id;
                    if(!!node.object.dest_bNotA._id){
                        let destUUID = "src-" + node.object.dest_bNotA._id;
                        let result = this.jsPlumb.connect({ uuids: [srcUUID, destUUID] });
                    }
                }
            }
            else if(node.type == "input") {
                if (node.object.dest_noResults) {
                    let srcUUID = "dest_noResults-" + node.object._id;
                    if(!!node.object.dest_noResults._id){
                        let destUUID = "src-" + node.object.dest_noResults._id;
                        let result = this.jsPlumb.connect({ uuids: [srcUUID, destUUID] });
                    }
                }
                if (node.object.dest_error) {
                    let srcUUID = "dest_error-" + node.object._id;
                    if(!!node.object.dest_error._id){
                        let destUUID = "src-" + node.object.dest_error._id;
                        let result = this.jsPlumb.connect({ uuids: [srcUUID, destUUID] });
                    }
                }
            }
            else if(node.type == "output") {
                if (node.object.dest_error) {
                    let srcUUID = "dest_error-" + node.object._id;
                    if(!!node.object.dest_error._id){
                        let destUUID = "src-" + node.object.dest_error._id;
                        let result = this.jsPlumb.connect({ uuids: [srcUUID, destUUID] });
                    }
                }
            }
           
            // all nodes
            if (node.object.dest) {
                let srcUUID = "dest-" + node.object._id;
                if(!!node.object.dest._id){
                    let destUUID = "src-" + node.object.dest._id;
                    let result = this.jsPlumb.connect({ uuids: [srcUUID, destUUID] });
                }
            }
        }
    },

    initDraggable(nodes) {

        if(this.isReadonly)
            return;

        this.jsPlumb.draggable(nodes, {
            containment: true,
            stop: function(e) {
                EventBus.$emit("node_dragStop", e);
                let node = e.el;
                node.style.zIndex = 1;
            }
        });
        this.jsPlumb.setDraggable(nodes, true);
    },

    setDragSelection(nodes) {
        this.jsPlumb.clearDragSelection();
        this.jsPlumb.addToDragSelection(nodes);
    },

    clearDragSelection() {
        this.jsPlumb.clearDragSelection();
    },

    validateConnection(srcNode, destNode) {
        return true;
    },
}



// WEBPACK FOOTER //
// ./src/util/jsPlumbUtil.js